import { render, staticRenderFns } from "./StaffMemberList.vue?vue&type=template&id=2e622ed0"
import script from "./StaffMemberList.vue?vue&type=script&lang=js"
export * from "./StaffMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports